import React, { useRef } from 'react';
import { observer } from 'mobx-react';
import './AdvancedSearch.scss';
import { AdvancedSearchVM } from './AdvancedSearchVM';
import stores from 'cd-eft/models/Stores';
import { Modal, ModalHeader, ModalBody } from 'reactstrap';
import Icon from '@mdi/react';
import { mdiCheckCircleOutline } from '@mdi/js';
import { setSortByValue } from '../Filter/FilterVM';

const libraryStore = stores.AppStore.projectsLibraryStore;

const AdvancedSearchComponent = () => {
  const vm = useRef(new AdvancedSearchVM()).current;

  return (
    <Modal
      size="xl"
      className="advanced-search"
      isOpen={libraryStore.advancedSearchIsOpen}
      toggle={vm.setTrigger}
      centered={false}
      aria-label="Advanced Search"
    >
      <ModalHeader toggle={vm.setTrigger}>
        <div className="mb-0 h2">Filter</div>
      </ModalHeader>

      <ModalBody>
        <div className="border-right-light">
          <fieldset className="usa-fieldset ">
            <legend className="usa-legend usa-legend--small">Sort By Date</legend>
            <RadioButton label="Descending" id={3} sortBy={libraryStore.sortBy} />
            <RadioButton label="Ascending" id={2} sortBy={libraryStore.sortBy} />
          </fieldset>
        </div>

        <div className="border-right-light">
          <fieldset className="usa-fieldset project-type-container">
            <legend className="usa-legend usa-legend--small">Project Type:</legend>
            <div className="project-type-content">
              {Object.keys(libraryStore.projectTypes).map((key) => (
                <SelectButton
                  className="mr-0"
                  key={`project-type-${key}`}
                  testid={`project-type-${key}`}
                  name={libraryStore.projectTypes[key]}
                  id={key}
                  active={libraryStore.filterProjectTypes.has(Number(key))}
                  onClick={(e) => vm.setProjectTypes(e, key)}
                />
              ))}
            </div>
          </fieldset>
        </div>
        <div>
          <fieldset className="usa-fieldset project-status-container">
            <legend className="usa-legend usa-legend--small"> Project Status:</legend>
            <div className="project-status-content">
              {libraryStore.projectStatuses.map((status) => (
                <SelectButton
                  key={`status-${status.id}`}
                  testid={`status-${status.id}`}
                  name={status.description}
                  id={status.id}
                  active={libraryStore.filterProjectStatuses.has(Number(status.id))}
                  onClick={(e) => vm.setProjectStatuses(e, status.id)}
                  disabled={libraryStore.filterProjectTypes.size === 0}
                />
              ))}
            </div>
          </fieldset>
        </div>
      </ModalBody>
    </Modal>
  );
};

export const AdvancedSearch = observer(AdvancedSearchComponent);

const SelectButton = (props: any) => {
  const activeClass = props.active ? 'active' : 'usa-button--outline';
  return (
    <button
      className={`usa-button mb-2 nobr ${activeClass} ${props.className}`}
      data-testid={props.testid}
      name={props.name}
      value={props.id}
      onClick={props.onClick}
      disabled={props.disabled}
    >
      {props.name}
      <Icon path={mdiCheckCircleOutline} className="ml-2" size={1} />
    </button>
  );
};

const RadioButton = (props: any) => {
  return (
    <div className="usa-radio">
      <input
        className={`usa-radio__input ${props.className}`}
        id={`sort-by-date-${props.id}`}
        data-testid={`sort-by-date-${props.id}`}
        aria-describedby="sort-by-date"
        type="radio"
        name={`sort-by-date-${props.id}`}
        value={Number(props.id)}
        checked={Number(libraryStore.sortBy) === Number(props.id)}
        onChange={setSortByValue}
      />
      <label className="usa-radio__label width-fit-content" htmlFor={`sort-by-date-${props.id}`}>
        {props.label}
      </label>
    </div>
  );
};
